"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZephyrTaskEventType = void 0;
var ZephyrTaskEventType;
(function (ZephyrTaskEventType) {
    ZephyrTaskEventType["Created"] = "task-created";
    ZephyrTaskEventType["AssignedRider"] = "task-assigned-rider";
    ZephyrTaskEventType["ArrivedAtCustomer"] = "task-arrived-at-customer";
    ZephyrTaskEventType["DeliveryStarted"] = "task-delivery-started";
    ZephyrTaskEventType["Delivered"] = "task-delivered";
    ZephyrTaskEventType["Failed"] = "task-failed";
    ZephyrTaskEventType["Deleted"] = "task-deleted";
    ZephyrTaskEventType["ArrivedAtStore"] = "task-arrived-at-store";
})(ZephyrTaskEventType = exports.ZephyrTaskEventType || (exports.ZephyrTaskEventType = {}));
